import { FetchRequest } from "./fetchRequest";

export function getCountryName(code, allCountries) {
  return allCountries.find((country) => country.id === code.toLowerCase())
    .title;
}

function prepareCountriesForClient(array) {
  return array.map((country) => {
    return {
      isVat: country.is_vat,
      id: country.code,
      title: country.title,
    };
  });
}

class Countries {
  async get() {
    const result = await FetchRequest({
      url: "/api/client/public/countries/",
      method: "GET",
    });
    return prepareCountriesForClient(result);
  }
}

const countriesInstance = new Countries();

export default countriesInstance;